import className from "classnames/bind";
import { useState } from "react";
import { Container } from "@components";
import CloseIcon from "@/assets/svg/close.svg";
import SearchIcon from "@/assets/svg/search.svg";

import styles from "./Search.module.scss";
import { useSearch } from "@/providers/SearchContext";
const cx = className.bind(styles);

type SearchFormProps = {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  handleFormSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  onSearchClear: () => void;
  placeholder?: string;
};

export default function SearchForm({
  searchTerm,
  setSearchTerm,
  handleFormSubmit,
  onSearchClear,
  placeholder = "",
}: SearchFormProps) {

  const [isFocused, setIsFocused] = useState(false);
  const { loading } = useSearch();
  const onInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearchTerm(value);
  };

  return (
    <div className={cx("search-form")}>
      <Container>
        <form onSubmit={handleFormSubmit} className={cx("search-form__form")}>
          <div className={cx(["search-input", { "focused": isFocused}])}>
            <SearchIcon className={cx("search-input__icon")} />
            <input
              type="text"
              name="search"
              readOnly={loading}
              placeholder={placeholder || "Search"}
              value={searchTerm}
              onBlur={() => { setIsFocused(false) }}
              onFocus={() => { setIsFocused(true) }}
              onInput={onInput}
              className={cx(["search-input__input", "text-m"])}
              enterKeyHint="done"
            />
            <button
              className={cx("search-input__clear")}
              onClick={onSearchClear}
              disabled={!searchTerm || loading}
              aria-label="Clear search"
              type="button"
            >
              <CloseIcon />
            </button>
          </div>
        </form>
      </Container>
    </div>
  );
}
